<template>
    <div class="vx-col maintenance flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
        <div class="lang">
            <i18n />
        </div>
        <img src="@/assets/images/pages/maintenance-2.png" alt="graphic-maintenance" class="mx-auto mb-4">
        <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">{{$t('tex_title')}}</h1>
        <p class="sm:mx-0 mx-4 mb-3">
            {{$t('tex_desc')}}
        </p>
        <p v-if="maintenance" class="sm:mx-0 mx-4 mb-6">
            {{$t('tex_date', {date: date})}}
        </p>
        <vs-button size="large" @click="update()">{{$t('tex_btn')}}</vs-button>
    </div>
</template>

<script>
import i18n from "@/widgets/i18n.vue";

export default {
    components: {
        i18n
    },
    computed: {
        maintenance() {
            return this.$store.state.maintenance
        },
        date() {
            return this.$moment(this.maintenance.time).format('DD.MM.YYYY HH:mm')
        }
    },
    methods: {
        update() {
            window.location.reload(true)
        }
    }
}
</script>

<style scoped lang="scss">
.lang{
    z-index: 100;
    top: 10px;
    right: 15px;
    position: absolute;
}
@media only screen and (max-width: 500px) {
    .maintenance{
        h1{
            font-size: 1.4rem !important;
        }
    }
}
</style>
